<template>
  <!-- click.stop we set stopPropagation on click event because we detect click on header outside search to close it -->
  <div class="header-search" :class="searchClass" @click.stop>
    <button class="header-search__button header-search__button_desktop" aria-label="Search" @click="sendSearchRequestAndCloseSearch">
      <span class="icon-search-bold header-search__icon"></span>
    </button>
    <button class="header-search__button header-search__button_mobile" aria-label="Search" @click="toggleSearchField">
      <span class="icon-search-bold header-search__icon"></span>
    </button>
    <div class="header-search__inner" :class="searchInnerClass">
      <input
        type="text"
        name="search-field"
        id="search-field"
        ref="search"
        class="header-search__field"
        :class="searchFieldClass"
        aria-label="Search field"
        :placeholder="langJson[lang].searchPlaceholder"
        @keyup.enter="sendSearchRequestAndCloseSearch"
        v-model="searchValue"
        v-resize="handleResize"
      />
      <div class="header-search__close icon-cancel" @click="clearAndFocus"></div>
      <div class="header-search__send icon-search-bold" @click="sendSearchRequestAndCloseSearch"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';

  const searchClass = ref('');
  const searchInnerClass = ref('');
  const searchFieldClass = ref('');
  const searchValue = ref('');
  const search = ref<HTMLInputElement | null>(null);

  const mainStore = useMainStore();
  const router = useRouter();

  const langJson = computed(() => mainStore.langJson);
  const lang = computed(() => mainStore.lang);
  const searchFieldState = computed(() => mainStore.searchFieldState);

  function setSearchFieldState(val: number) {
    mainStore.setSearchFieldState(val);
  }

  function sendSearchRequestAndCloseSearch() {
    if (searchValue.value !== '') {
      router.push({
        path: '/search/',
        query: { q: searchValue.value }
      });
      setSearchFieldState(0);
    }
  }

  function searchFieldInitState() {
    const width = window.innerWidth;
    if (width > 1023) {
      setSearchFieldState(1);
    } else {
      setSearchFieldState(0);
    }
  }

  function handleResize() {
    if (document.activeElement?.id === 'search-field') return;
    let width = window.innerWidth;
    if (width > 1023) {
      if (searchFieldState.value == 0) setSearchFieldState(1);
      searchClass.value = '';
      searchInnerClass.value = '';
    } else {
      if (searchFieldState.value == 1) setSearchFieldState(0);
    }
  }

  function toggleSearchField() {
    if (searchFieldState.value > 0) {
      setSearchFieldState(0);
    } else {
      setSearchFieldState(1);
      setTimeout(() => {
        setFocus();
      }, 500);
    }
  }

  function clearSearchValue() {
    searchValue.value = '';
  }

  function setFocus() {
    if (search.value) search.value.focus();
  }

  function clearAndFocus() {
    clearSearchValue();
    setFocus();
  }

  watch(searchFieldState, () => {
    if (searchFieldState.value > 0) {
      searchClass.value = 'header-search_opened';
      searchInnerClass.value = 'header-search__inner_opened';
    } else {
      searchClass.value = 'header-search_closed';
      searchInnerClass.value = 'header-search__inner_closed';
    }
  });

  watch(searchValue, (val) => {
    if (val) {
      searchFieldClass.value = 'header-search__field_filled';
    } else {
      searchFieldClass.value = 'header-search__field_empty';
    }
  });

  onMounted(() => {
    // Run after hydration to keep SSR/CSR HTML in sync
    searchFieldInitState();
    handleResize();
  });
</script>
